import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {timeFormat} from 'd3-time-format'
import {Link} from 'react-router-dom'
import {Table as AntTable} from 'antd'

import style from './table.sass'

const columns = [{
  title: 'Filter name',
  dataIndex: 'name',
  width: '40%',
  render: (text, record) => (
    <Link to={`/stock-filters/builder/${record.id}`} className='btn-link'>{text}</Link>
  )
}, {
  title: 'Date modified',
  dataIndex: 'modified_date',
  width: '40%',
  render: (text) => (
    timeFormat('%b %d, %Y, %I:%M %p')(new Date(text))
  )
}, {
  title: '# of Tickers',
  width: '20%',
  render: (text, record) => (
    record.selected_tickers.tickers.length
  )
}]

@inject('store') @observer
class Table extends Component {
  state = {
    height: 0
  }
  componentDidMount() {
    this.props.store.stockFilter.list.load()
    this.calculateHeight()
    window.addEventListener('resize', this.calculateHeight)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateHeight)
  }
  calculateHeight = () => {
    const box = document.querySelector('.ant-table-body')?.getBoundingClientRect()
    if (!box) {
      return
    }
    const windowHeight = window.innerHeight
    this.setState({
      height: Math.max((windowHeight - box.top - 215), 200)
    })
  }
  changePage = (page) => {
    this.props.store.stockFilter.list.load(page)
  }
  select = (keys) => {
    this.props.store.stockFilter.list.select(keys)
  }

  render() {
    const {stockFilter} = this.props.store
    const {list} = stockFilter
    const {data, loading, pagination, selected} = list
    const empty = !loading && !data.length
    if (empty) {
      return(
        <h4>
          You do not have stock filters.{' '}
          <Link to='/stock-filters/builder' style={{color: '#337ab7'}}>
            Would you like to create a new one?
          </Link>
        </h4>
      )
    } else {
      return(
        <AntTable
          className='card'
          styleName='table'
          rowSelection={{
            selectedRowKeys: selected,
            onChange: this.select
          }}
          columns={columns}
          dataSource={data}
          rowKey={'id'}
          size='small'
          scroll={{y: this.state.height}}
          loading={loading}
          pagination={{
            total: pagination.count,
            pageSize: pagination.size,
            current: pagination.page,
            onChange: this.changePage,
            showTotal: total => `Total ${total} items`
          }}
          locale={loading ? {
            emptyText: 'Loading'
          } : {
            emptyText: 'No Data'
          }}
        />
      )
    }
  }
}

export default Table
